export const LOAD_ONBOARDING_SUCCESSFUL = 'onboarding/LOAD_ONBOARDING_SUCCESSFUL';
export const UPDATE_HEADER_INFO = 'onboarding/UPDATE_HEADER_INFO';
export const UPDATE_SIDE_PANEL_SELECTED_TAB = 'onboarding/UPDATE_SIDE_PANEL_SELECTED_TAB';
export const SELECT_INSTRUMENT = 'onboarding/SELECT_INSTRUMENT';
export const SELECT_ANALYTE = 'onboarding/SELECT_ANALYTE';
export const UPDATE_ALL_INSTRUMENT_ANALYTES = 'onboarding/UPDATE_ALL_INSTRUMENT_ANALYTES';
export const UPDATE_ANALYTE = 'onboarding/UPDATE_ANALYTE';
export const UNDO_ANALYTE_CHANGES = 'onboarding/UNDO_ANALYTE_CHANGES';
export const CHECKED_ANALYTE = 'onboarding/CHECKED_ANALYTE';
export const UNCHECKED_ALL_ANALYTE = 'onboarding/UNCHECKED_ALL_ANALYTE';
export const SAVE_ANALYTES_SUCCESSFUL = 'onboarding/SAVE_ANALYTES_SUCCESSFUL';
export const SAVE_ANALYTES_STARTS = 'onboarding/SAVE_ANALYTES_STARTS';
export const SAVE_ANALYTES_DONE = 'onboarding/SAVE_ANALYTES_DONE';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/onboarding/onboarding.const.ts